import { useEffect, useState } from 'react';

const currentRatio = () => window.devicePixelRatio || 1;

export default function useDevicePixelRatio(): number {
  const [ratio, setRatio] = useState(currentRatio);

  useEffect(() => {
    const media = window.matchMedia(`(resolution: ${ratio}dppx)`);
    const update = () => setRatio(currentRatio());
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, [ratio]);

  return ratio;
}
